"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_1 = require("react-science/ui");
const DispatchContext_1 = require("../../context/DispatchContext");
function AboutUsZakodium() {
    const [isSecretOpen, openSecret] = (0, ui_1.useOnOff)();
    function handleClick(event) {
        if (event.shiftKey && event.altKey) {
            openSecret();
        }
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("span", { onClick: handleClick, children: "Zakodium" }), ` Sàrl (Switzerland).`, isSecretOpen && (0, jsx_runtime_1.jsx)(SecretThrower, {})] }));
}
exports.default = AboutUsZakodium;
const ThrowerDiv = styled_1.default.div `
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
/**
 * This component is here for us so we can test the impact of thrown exceptions
 * in the deployed application.
 */
function SecretThrower() {
    const [shouldThrow, setShouldThrow] = (0, ui_1.useOnOff)();
    const dispatch = (0, DispatchContext_1.useDispatch)();
    if (shouldThrow) {
        throw new Error('Error thrown in React render');
    }
    return ((0, jsx_runtime_1.jsxs)(ThrowerDiv, { children: [(0, jsx_runtime_1.jsx)(ui_1.Button, { onClick: setShouldThrow, children: "Throw in React render" }), (0, jsx_runtime_1.jsx)(ui_1.Button, { onClick: () => dispatch({
                    type: 'SECRET_THROW_ERROR',
                    payload: { randomNumber: Math.random() },
                }), children: "Throw in main reducer" })] }));
}
